import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import generalActions from 'redux/actions/generalActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import collaborateCretionToolSelector from 'redux/selectors/collaborate/collaborate_creation_tool_container_selector'

import QuickLaunchCollaborateCreate from 'views/quick_launch/collaborate/collaborate_create/ql_collaborate_create_modal_view'

class QuickLaunchCollaborateCreateModalContainer extends PureComponent {

	closeModalHandler = () => {
		this.props.actions.closeModal(this.props.modalName)
	}

	render() {
		return (
			<QuickLaunchCollaborateCreate
				collaborateUrl={this.props.collaborateUrl}
				closeModalHandler={this.closeModalHandler}
			/>
		)
	}

}

function mapStateToProps(state, props) {
	return collaborateCretionToolSelector(state, props)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: generalActions.closeModal,
	}, dispatch)
}

QuickLaunchCollaborateCreateModalContainer.propTypes = {
	modalName: PropTypes.string.isRequired,
	actions: PropTypes.shape({
		closeModal: PropTypes.func.isRequired,
	}),
	collaborateUrl: PropTypes.string.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(
	QuickLaunchCollaborateCreateModalContainer
)

export { QuickLaunchCollaborateCreateModalContainer }
